/**
 * Try to use separate files in /components/
 *
 * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
 * Since it is only registered in actions.php
 */

import './components/breakpoint-change';
import './components/offcanvas';
import Accordion from './components/accordion';
import { form } from './components/form';
import './components/header';
import './components/footer-menus';
import './components/fancybox';
import notificationBar from './components/notification-bar';

document.addEventListener('DOMContentLoaded', () => {
	// mobileMenu();
	form();
	notificationBar();

	if (document.querySelector('[data-lottie]')) {
		import('./components/lottie').then((lottie) => {
			lottie.default();
		});
	}

	// accordions
	const accordions = document.querySelectorAll('[data-details]');
	if (accordions.length) {
		accordions.forEach((accordion) => {
			new Accordion(accordion);
		});
	}
});
